import ChatBody from "components/Chat/ChatBody";
import ChatFooter from "components/Chat/ChatFooter";
import ChatHeader from "components/Chat/ChatHeader";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { Container, Spinner } from "reactstrap";
import { resolutionChat } from "store/actions/resolutionCenterAction";

const ResolutionChat = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { resolutionchats, isLoading } = useSelector(
    (state) => state.resolution
  );

  useEffect(() => {
    dispatch(resolutionChat(id));
  }, []);

  return (
    <>
      <Container fluid className="my-4">
        <ChatHeader />
        {isLoading ? (
          <div className="d-flex align-items-center justify-content-center vh-100">
            <td colSpan="9" className="text-center">
              <Spinner />
            </td>
          </div>
        ) : (
          <>
            <ChatBody
              ticketChat={resolutionchats?.chats}
              id={id}
              SingleResolution={resolutionchats.athleteData}
            />
            <ChatFooter athleteData={resolutionchats.athleteData} />
          </>
        )}
      </Container>
    </>
  );
};

export default ResolutionChat;
